import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newPhone/default.svg'


const _withScopeId = n => (_pushScopeId("data-v-2c7e75d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap" }
const _hoisted_2 = { class: "mod_c_title" }
const _hoisted_3 = {
  key: 1,
  class: "community"
}
const _hoisted_4 = { class: "picture" }
const _hoisted_5 = { class: "picture_lef" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "picture_img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_7 = { class: "bottom_right" }
const _hoisted_8 = { class: "KV_img" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "number-show" }
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "container_rig" }
const _hoisted_13 = { class: "container_rig_one" }
const _hoisted_14 = { class: "Concurrent" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Concurrent_t" }, [
  /*#__PURE__*/_createTextVNode("在线并发限制: "),
  /*#__PURE__*/_createElementVNode("span", { class: "Concurrent_gk" }, "最高上限 "),
  /*#__PURE__*/_createTextVNode("  ")
], -1))
const _hoisted_16 = { class: "question_mark" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "'0'表示无观看人数上限", -1))
const _hoisted_18 = { class: "Virtual_number" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "Default_base" }
const _hoisted_21 = { class: "question_mark" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "给真实人数添加上固定的虚拟人数。", -1))
const _hoisted_23 = { class: "watch" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w_g" }, "人数放大公式:  每增加一次真实用户访问量, 显示人数增加 ", -1))
const _hoisted_25 = { class: "question_mark" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, [
  /*#__PURE__*/_createTextVNode("用户每访问频道一次，会在真实访问量上，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("再增加设置的区间值内的随机数。")
], -1))
const _hoisted_27 = { class: "Virtual_number_x" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "v_x" }, "虚拟人数上限:  ", -1))
const _hoisted_29 = { class: "question_mark" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "默认基础人数 + 观看人数放大 >= 虚拟人数上限，频道将只会增长真实用户访问量。", -1))
const _hoisted_31 = { class: "Final" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "f_z" }, "最终人数:", -1))
const _hoisted_33 = { class: "f_n" }
const _hoisted_34 = { class: "question_mark" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, [
  /*#__PURE__*/_createTextVNode("一次性设置频道的当前想要的人数，最低不能低于真实人数，最高不限制，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 超过真实人数的数量会将超出的人数增加到观看人数放大记录中。")
], -1))
const _hoisted_36 = { class: "tow_o" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "two_t" }, "2. 该数据只为前端用户展现, 后台数据以真实数据统计。", -1))
const _hoisted_38 = { class: "preservation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Crumb = _resolveComponent("Crumb")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_c_loading = _resolveComponent("c-loading")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_QuestionCircleFilled = _resolveComponent("QuestionCircleFilled")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 人数设置 "),
        _createVNode(_component_a_switch, {
          class: "btns_txt",
          checkedValue: 0,
          unCheckedValue: 1,
          onChange: _ctx.switchChange,
          checked: _ctx.opened,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.opened) = $event))
        }, null, 8, ["onChange", "checked"])
      ]),
      (_ctx.showLoading)
        ? (_openBlock(), _createBlock(_component_c_loading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("ul", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        src: _ctx.viewImgPlayerUrl,
                        alt: ""
                      }, null, 8, _hoisted_9),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_UserOutlined),
                        _createTextVNode(" 0")
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("ul", _hoisted_12, [
                _createElementVNode("li", _hoisted_13, [
                  _createTextVNode(" 人数显示模式:   "),
                  _createVNode(_component_a_radio_group, {
                    value: _ctx.valued,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.valued) = $event)),
                    onChange: _ctx.numSwitchChange
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, {
                        value: 1,
                        class: "one"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("实时在线(并发)")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, { value: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode("用户量(UV)")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, { value: 3 }, {
                        default: _withCtx(() => [
                          _createTextVNode("累计访问量(PV,支持放大)")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, { value: 4 }, {
                        default: _withCtx(() => [
                          _createTextVNode("关闭显示")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "onChange"])
                ]),
                _createElementVNode("li", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_a_input_number, {
                    id: "inputNumber",
                    min: 0,
                    max: 10000000,
                    value: _ctx.concurrency,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.concurrency) = $event)),
                    parser: (value) => value.replace(/[^0-9]/g, '')
                  }, null, 8, ["value", "parser"]),
                  _createElementVNode("p", _hoisted_16, [
                    _createVNode(_component_a_popover, { placement: "right" }, {
                      content: _withCtx(() => [
                        _hoisted_17
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_QuestionCircleFilled, { class: "QuestionCircleFilled" })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("li", _hoisted_18, [
                  _createTextVNode(" 虚拟人数开关:   "),
                  _createVNode(_component_a_radio_group, {
                    value: _ctx.valuek,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.valuek) = $event)),
                    class: "number_open",
                    disabled: _ctx.valued == 1 || _ctx.valued == 2 || _ctx.valued == 4 ? true : false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, { value: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode("开")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, { value: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("关")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ]),
                (!_ctx.valuek)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("li", _hoisted_20, [
                        _createTextVNode(" 虚拟基础人数:   "),
                        _createVNode(_component_a_input_number, {
                          id: "inputNumber",
                          min: 0,
                          max: 10000000,
                          value: _ctx.defaultNumber,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.defaultNumber) = $event)),
                          parser: (value) => value.replace(/[^0-9]/g, '')
                        }, null, 8, ["value", "parser"]),
                        _createTextVNode("人 "),
                        _createElementVNode("p", _hoisted_21, [
                          _createVNode(_component_a_popover, { placement: "right" }, {
                            content: _withCtx(() => [
                              _hoisted_22
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionCircleFilled, { class: "QuestionCircleFilled" })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("p", null, [
                          _createVNode(_component_a_input_number, {
                            id: "inputNumber",
                            min: 0,
                            max: 999,
                            value: _ctx.min_number,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.min_number) = $event)),
                            parser: (value) => value.replace(/[^0-9]/g, '')
                          }, null, 8, ["value", "parser"]),
                          _createTextVNode(" -  "),
                          _createVNode(_component_a_input_number, {
                            id: "inputNumber",
                            min: 0,
                            max: 999,
                            value: _ctx.max_number,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.max_number) = $event)),
                            parser: (value) => value.replace(/[^0-9]/g, '')
                          }, null, 8, ["value", "parser"])
                        ]),
                        _createElementVNode("p", _hoisted_25, [
                          _createVNode(_component_a_popover, { placement: "right" }, {
                            content: _withCtx(() => [
                              _hoisted_26
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionCircleFilled, { class: "QuestionCircleFilled" })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("p", null, [
                          _createVNode(_component_a_input_number, {
                            id: "inputNumber",
                            min: 0,
                            max: 10000000,
                            value: _ctx.max,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.max) = $event)),
                            parser: (value) => value.replace(/[^0-9]/g, '')
                          }, null, 8, ["value", "parser"])
                        ]),
                        _createTextVNode("   "),
                        _createElementVNode("p", _hoisted_29, [
                          _createVNode(_component_a_popover, { placement: "right" }, {
                            content: _withCtx(() => [
                              _hoisted_30
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionCircleFilled, { class: "QuestionCircleFilled" })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("p", _hoisted_33, [
                          _createVNode(_component_a_input_number, {
                            id: "inputNumber",
                            min: 0,
                            max: 10000000,
                            value: _ctx.final_people,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.final_people) = $event)),
                            parser: (value) => value.replace(/[^0-9]/g, '')
                          }, null, 8, ["value", "parser"])
                        ]),
                        _createElementVNode("p", _hoisted_34, [
                          _createVNode(_component_a_popover, { placement: "right" }, {
                            content: _withCtx(() => [
                              _hoisted_35
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_QuestionCircleFilled, { class: "QuestionCircleFilled" })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_36, [
                        _createTextVNode(" 注: "),
                        _createElementVNode("p", null, " 1. 显示观众人数(" + _toDisplayString(_ctx.allNum) + ") =  真实观众(" + _toDisplayString(_ctx.pv_number) + ") +  默认观众人数 (" + _toDisplayString(_ctx.default_number) + ")  +  观看人数放大(" + _toDisplayString(_ctx.false_number) + ")； ", 1)
                      ]),
                      _hoisted_37
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", _hoisted_38, [
                  _createVNode(_component_a_button, {
                    class: "preservation_p",
                    type: "primary",
                    onClick: _ctx.save
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ]))
    ])
  ], 64))
}